import React from 'react';

interface TypographyProps {
  className?: string;
  children?: React.ReactNode;
  as?: keyof JSX.IntrinsicElements;
}

const Typography = ({ className, children, as = 'p' }: TypographyProps) => {
  const Component = as;
  return <Component className={className}>{children}</Component>;
};

export default Typography;
